import { store } from "../../../../../redux/store";
import { t } from "../../../../core/translate";
import { selectors as brandSelectors } from "../../../../../redux/brand";
import { actions as licenseActions } from "../../../../../redux/license";
import { actions as modalActions } from "../../../../../redux/modals";
import { gaEvent } from "../../../../utils/analytics";
import MenuItem from "../../../../components/list-item";

export const redeemCodes = () => {
  const state = store.getState();
  const dispatch = store.dispatch;
  const showRedeem = brandSelectors.getBrandValue(state, "Menu.redeem");

  return MenuItem({
    condition: showRedeem,
    onClick: event => {
      event.preventDefault();
      gaEvent("header/redeem-modal");
      dispatch(modalActions.openRedeemModal());
    },
    text: t("redeem.redeem-codes", "Redeem Codes")
  });
};

export const updateLicense = () => {
  const state = store.getState();
  const dispatch = store.dispatch;
  const showUpdateLicense = brandSelectors.getBrandValue(
    state,
    "Menu.update_license"
  );

  return MenuItem({
    condition: showUpdateLicense,
    onClick: event => {
      event.preventDefault();
      gaEvent("header/update-license");
      dispatch(licenseActions.updateLicense());
    },
    text: t("main-menu.update", "Update Library")
  });
};

export const sharing = () => {
  const state = store.getState();
  const dispatch = store.dispatch;
  // sometimes we want sharing off in library but on elsewhere
  const showLibrarySharing = brandSelectors.getBrandValue(state, "Library.sharing");
  const showSharing = brandSelectors.getBrandValue(state, "Menu.sharing");
  const sharingEnabled = brandSelectors.getBrandValue(state, "Sharing.enabled");

  return MenuItem({
    condition: showLibrarySharing && showSharing && sharingEnabled,
    onClick: event => {
      event.preventDefault();
      gaEvent("header/manage-sharing");
      dispatch(
        modalActions.openModal("SharingModal", {
          wrapWithDialog: true,
          size: "large",
          title: t("sharing.sharing", "Sharing"),
          toggleCloseButton: () => {}
        })
      );
    },
    text: t("sharing.sharing", "Sharing")
  });
};

export const highlighters = () => {
  const state = store.getState();
  const dispatch = store.dispatch;
  // sometimes we want highlighters off in library but on elsewhere
  const showLibraryHighlighters = brandSelectors.getBrandValue(state, "Library.highlights");
  const showHighlighters = brandSelectors.getBrandValue(
    state,
    "Menu.highlighters"
  );

  return MenuItem({
    condition: showLibraryHighlighters && showHighlighters,
    onClick: event => {
      event.preventDefault();
      gaEvent("header/manage-highlighters");
      dispatch(modalActions.openModal("HighlightersModal"));
    },
    text: t("main-menu.highlighters", "Highlighters")
  });
};

export const facultyUpload = () => {
  const state = store.getState();
  const dispatch = store.dispatch;
  const showfacultyUpload = brandSelectors.getBrandValue(
    state,
    "Menu.faculty_upload"
  );
  const isInstructor = Fraction.Helpers.isInstructor();

  return MenuItem({
    condition: showfacultyUpload && isInstructor,
    onClick: event => {
      event.preventDefault();
      gaEvent("header/faculty-upload");
      dispatch(
        modalActions.openModal("FacultyUploadModal", {
          wrapWithDialog: true,
          size: "large",
          title: t("main-menu.faculty-upload", "Faculty Upload"),
          secondaryActionButton: {
            label: t("base.cancel", "Cancel"),
            onClick: () => {
              store.dispatch(modalActions.closeModal());
            }
          },
          primaryActionButton: {
            label: t("sso.finish-account", "Get Started"),
            onClick: () => {
              event.preventDefault();
              window.location =
                "mailto:publisherops@vitalsource.com?subject=Add my OER content to Bookshelf!";
            }
          },
          darkHeader: true
        })
      );
    },
    text: t("main-menu.faculty-upload", "Faculty Upload")
  });
};
